import { Box, Grid } from '@mui/material'
import {
  ContentWrapper,
  DatePickerWrapper,
  DatePickerWrapperProps,
  LabeledItem
} from '.'
import { useIsMobile } from '../contexts'
import { useFieldValue } from '../hooks'

interface DateRangeLabelProps {
  translationId: string
}

export interface DateRangeProps {
  endDateProps: DatePickerWrapperProps
  hideRange?: boolean
  spacing: number
  startDateProps: DatePickerWrapperProps
}

export const DateRange = ({
  endDateProps,
  hideRange = false,
  spacing,
  startDateProps
}: DateRangeProps) => {
  const isMobile = useIsMobile()

  const startDateValue = useFieldValue(startDateProps.name)
  const endDateValue = useFieldValue(endDateProps.name)

  return (
    <ContentWrapper showContent={!hideRange}>
      <Grid container>
        <Grid item md={6} xs={12}>
          <DatePickerWrapper
            {...startDateProps}
            fullWidth
            maxDate={endDateValue}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <Box marginLeft={isMobile ? 0 : spacing}>
            <DatePickerWrapper
              {...endDateProps}
              fullWidth
              minDate={startDateValue}
            />
          </Box>
        </Grid>
      </Grid>
    </ContentWrapper>
  )
}

export interface LabelAndDateRangeProps extends DateRangeProps {
  labelProps: DateRangeLabelProps
}

export const LabelAndDateRange = ({
  hideRange = false,
  labelProps,
  ...dateRangeProps
}: LabelAndDateRangeProps) => {
  return (
    <LabeledItem
      showContent={!hideRange}
      labelTranslationId={labelProps.translationId}
    >
      <DateRange {...dateRangeProps} />
    </LabeledItem>
  )
}
